import React from "react";
import { FormattedMessage } from "react-intl";
import { useLanderConfig } from "../commons/ConfigContext";
import { QueryParam, System } from "../commons/Constants";
import { YahooContent } from "../yahoo/YahooContent";
import { AdSense } from "./utils/adSenseUtils";
import { useAdsenseContext } from "./AdsenseContext";
import { useExperiment } from "../experimentation";
import { ExperimentIds } from "../commons/constants/experiment";
import { GDAds } from "../inHouseAds/GDAds";

function AdSenseBlock({ landerConfig, page, queryConfig }) {
  let adsenseContentDivId = "ads";
  if (page === AdSense.page.RELATED_LINKS) {
    adsenseContentDivId = "relatedLinks";
  }

  let search;
  if (
    !landerConfig.lander.template.includes("PARK_WEB") &&
    queryConfig[QueryParam.SEARCH_BOX]
  ) {
    search = (
      <div id="searchbox">
        <FormattedMessage id="contentBlockedText" />
      </div>
    );
  }

  return (
    <>
      <div data-testid={ adsenseContentDivId } id={ adsenseContentDivId }>
        <FormattedMessage id="contentBlockedText" />
      </div>
      {search}
    </>
  );
}

export function AdContent({ page }: { page: string }) {
  const { landerConfig, queryConfig } = useLanderConfig();
  const { hasAdsense } = useAdsenseContext();
  const { inTreatmentCohort: yahooGoogleTrafficExperiment } = useExperiment(
    ExperimentIds.yahooFeedPart2Id
  );

  if (landerConfig.isForcedYahoo || yahooGoogleTrafficExperiment) {
    return (
      <YahooContent
        yahooGoogleTrafficExperiment={ yahooGoogleTrafficExperiment }
      />
    );
  }

  if (hasAdsense === false) {
    if (landerConfig.system === System.PARKWEB) {
      return <GDAds landerConfig={ landerConfig } />;
    }
    return <YahooContent />;
  }

  return (
    <AdSenseBlock
      landerConfig={ landerConfig }
      queryConfig={ queryConfig }
      page={ page }
    />
  );
}
